import { lazy } from 'solid-js'
import { messages } from '../../pages/all-featured-destination-page/all-featured-destination-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/all-featured-destination-page/all-featured-destination-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/all/vacation-rentals',
    titleMessage: messages.titleMessage,
}
